// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"2a105111","725":"665c0e36","857":"141ae62b","977":"b618e159"}[chunkId] + ".chunk.js";
};